import { gql } from '@apollo/client';

export const fetchMICampaignsQuery = gql`
  query getCampaigns(
    $campaignFilterInfo: CampaignFilterInfoInput
    $pagination: Pagination
    $search: String
    $sort: Sort
  ) {
    campaigns(
      campaignFilterInfo: $campaignFilterInfo
      pagination: $pagination
      sort: $sort
      search: $search
    ) {
      results {
        id
        name
        campaignState
        campaignTypeDefinition
      }
    }
  }
`;

export const fetchMIWorkflowsQuery = gql`
  query getWorkflows(
    $filterInfo: WorkflowFilterInfoInput
    $pagination: Pagination
    $sort: Sort
    $search: String
  ) {
    workflows(filterInfo: $filterInfo, pagination: $pagination, sort: $sort, search: $search) {
      results {
        id
        name
      }
    }
  }
`;

export const fetchMIMessageTypesQuery = gql`
  query getMessageTypes($messageMedium: MessageMediumDefinition) {
    messageTypes(messageMedium: $messageMedium) {
      id
      name
      messageChannel {
        name
        id
        channelType
      }
    }
  }
`;

export const fetchMockSnippetsByCampaignIds = gql`
  query getSnippetsByCampaignIds(
    $campaignIds: [Long]!
    $startDate: Long!
    $endDate: Long!
    $pagination: Pagination!
    $sort: Sort!
    $search: String!
  ) {
    snippetsByCampaignIds(
      campaignIds: $campaignIds
      startDate: 123
      endDate: 456
      pagination: $pagination
      sort: $sort
      search: $search
    ) {
      info {
        count
        offset
        limit
        page
      }
      results {
        id
        snippetName
        parentSnippet
        metrics {
          TotalSent
          TotalClicks
          UniqueClicks
        }
        links {
          total
          data {
            id
            url
            variations {
              total
              data {
                dynamicUrl
                metrics {
                  TotalClicks
                  UniqueClicks
                }
              }
            }
          }
        }
        campaigns {
          campaignId
          campaignName
          campaignType
          campaignState
          thumbnailSrc
          metrics {
            TotalSent
            TotalClicks
            UniqueClicks
          }
        }
      }
    }
  }
`;
